import { includes } from "lodash/fp";
import { useParams } from "react-router-dom";

import useRecommendations from "@app/analytics/hooks/recommendations/useRecommendations";
import { Recommendation } from "@app/analytics/types";

const getRecommendationsForSession = (
  sessionId: string,
  allRecommendations: Recommendation[]
): Recommendation[] =>
  allRecommendations.filter((recommendation) =>
    includes(sessionId, recommendation.meetingContext.sessionIds)
  );

const DEFAULT_RECOMMENDATION_STATE = {
  isInitialLoading: false,
  isError: false,
  recommendations: [],
};

const useMeetingReportRecommendations = () => {
  const { sessionId } = useParams();

  const { loading, error, pendingRecommendations } = useRecommendations({
    enabled: Boolean(sessionId),
  });

  if (!sessionId) {
    return DEFAULT_RECOMMENDATION_STATE;
  }

  const recommendations = getRecommendationsForSession(
    sessionId,
    pendingRecommendations
  );

  return {
    isInitialLoading: loading,
    isError: error,
    recommendations,
  };
};

export default useMeetingReportRecommendations;
